module.exports = __webpack_public_path__ + "static/img/zs_4.34b1a26f.png";